<div class="restart-dialog">
  <div class="dialog-heading">
    <span class="dialog-icon" aria-hidden="true"><i class="bi bi-arrow-repeat"></i></span>
    <div>
      <p class="dialog-eyebrow">Confirm action</p>
      <h2 mat-dialog-title>Reprocess this Pure Original?</h2>
    </div>
  </div>
  <mat-dialog-content>
    <p>{{ data }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button type="button" class="cancel-button" (click)="canceledOption()">Cancel</button>
    <button type="button" class="confirm-button" (click)="confirmedOption()"><i class="bi bi-arrow-repeat" aria-hidden="true"></i> Reprocess</button>
  </mat-dialog-actions>
</div>
